import { Link } from 'react-router-dom';
import VLibras from 'react-vlibras';
import Header from './headerFisio'; 
import AboutFisio from './AboutFisio';
import Fisioterapia from './CorpoClinicoFisio';

const About = () => {
    return (
      <div>
        <Header />
        <VLibras />
        <AboutFisio />
        <Fisioterapia />
      </div>
    );
  };
  
  export default About;
  